import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import assetModule from './modules/asset';
import configModule from './modules/config';
import geoModule from './modules/geo';
import productModule from './modules/product';
import cartModule from './modules/cart';
import feedbackModule from './modules/feedback';
import authModule from './modules/auth';
import customerModule from './modules/customer';
import deliveryModule from './modules/delivery';
import catalogModule from './modules/catalog';
import contactUsModule from './modules/contact_us';

export default new Vuex.Store({
    //strict: true,
    modules: {
        asset: assetModule,
        config: configModule,
        geo: geoModule,
        product: productModule,
        cart: cartModule,
        feedback: feedbackModule,
        auth: authModule,
        customer: customerModule,
        delivery: deliveryModule,
        catalog: catalogModule,
        contactUs: contactUsModule,
    },
    getters: {
        getConfig: (state) => (key, defaultValue) => {
            let keys = key.split('.');

            let value = state.config;

            for (let i in keys) {
                value = value[keys[i]];

                if (!value) {
                    return defaultValue ? defaultValue : '';
                }
            }

            return value;
        }
    },
});
